import { Divider } from '@mui/material'
import React, { useContext } from 'react'
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage'
import { CapituloComponent } from './CapituloComponent'



export const TablaCapitulos = ({capitulos}) => {
  //const {modalAgregaPrioridad, setModalAgregaPrioridad} = useContext(PrioridadesContext);
  console.log('capitulos recibidas en tabla', capitulos)

  return (
    <div
        style={{
            display:'column',
            maxWidth:700,
            marginTop:20,
            maxHeight:'60%',
            overflowY:'auto'
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row'
        }}
      >
        <div
          style={{
            fontSize:14,
            fontWeight:'bold'
          }}
        >
          Capítulos
        </div>
      </div>
      <Divider />
      {
        capitulos?.map(capitulo => (
          <CapituloComponent capitulo={capitulo} />
        ))
      }
    </div>
  )
}
